import {mapQuizSessionDbToType, QuizSession} from '@cp/model';
import {undefinedIfThrowSync} from '@coolcolduk/util';
import {onSnapshot} from 'firebase/firestore';
import {getQuizSessionDocRef} from './getQuizSessionDocRef';

export default function subscribeQuizSessionDoc(
  uid: string,
  sessionId: string,
  onData: (session: QuizSession | undefined) => void,
  onError?: (err: Error) => void,
): () => void {
  const ref = getQuizSessionDocRef(uid, sessionId);
  return onSnapshot(
    ref,
    (snapshot) => {
      const data = undefinedIfThrowSync(() => mapQuizSessionDbToType(snapshot));
      onData(data);
    },
    (err) => onError?.(err),
  );
}
